import { createRouter, createWebHashHistory} from "vue-router";
import Home from "../ListaCollezioni.vue";
import Products from "../ListaProdotti.vue";
import Product from "../MyProdotto.vue";
import Ispirazioni from "../MyIspirazioni.vue";
import SelectMood from "../SelectMood.vue";
import GammeAccessori from "../GammeAccessori.vue";
import ListaAccessori from "../ListaAccessori.vue";
import CarrelloShop from '../CarrelloShop.vue';
const routes = [
  {
    path: "/",
    component: Home,
    name: "home",
  },
  {
    path: "/ispirazioni/:ispirazioni?",
    component: Ispirazioni,
    name: "ispirazioni"
  },
  {
    path: "/products/:collezione",
    component: Products,
    name: "prodotti",
  },
  {
    path: "/product/:prodotto",
    component: Product,
    name: "prodotto",
  },
  {
    path: "/mood",
    component: SelectMood,
    name: "mood",
  },
  {
    path: "/gamme-accessori",
    component: GammeAccessori,
    name: "gamme"
  },
  {
    path: "/accessori/:gamma",
    component: ListaAccessori,
    name: "accessori"
  },
  {
    path: "/carrello-shop",
    component: CarrelloShop,
    name: "carrello-shop"
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior () {
    return { left: 0, top: 0 }
  }
});

router.beforeEach((to, from, next) => {
  // Questo codice verrà eseguito ogni volta che la rotta cambia
  window.document.getElementById('app').scrollIntoView()

  // Si assicura che il cambio di rotta si completi
  next()
})

export default router;